import { getUrlParams } from './getUrlParams';

export const getStageMode = () => {
	return !!getUrlParams()?.stageMode;
};
